// src/pages/LoginPage.js

import React, { useState } from 'react';

import axios from 'axios';

import { useNavigate, Link as RouterLink } from 'react-router-dom';

import { Box, Button, TextField, Typography, Container, Paper, Grid, Link } from '@mui/material';


const LoginPage = ({ onLogin }) => {

  const [email, setEmail] = useState('curielricardo@hotmail.com');

  const [password, setPassword] = useState('unapasswordsegura');

  const [error, setError] = useState('');

  const navigate = useNavigate();

  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';


  const handleSubmit = async (event) => {

    event.preventDefault();

    setError('');

    

    const params = new URLSearchParams();

    params.append('username', email);

    params.append('password', password);


    try {

      const response = await axios.post(`${apiUrl}/token`, params);

      const { access_token } = response.data;

      

      localStorage.setItem('accessToken', access_token);

      // Guardamos el email para simular el rol de admin

      localStorage.setItem('userEmail', email); 

      onLogin(email);

      navigate('/');


    } catch (err) {

      setError('Usuario o contraseña incorrectos.');

      console.error('Error de login:', err);

    }

  };


  return (

    <Container component="main" maxWidth="xs">

      <Paper elevation={6} sx={{ marginTop: 8, padding: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

        <img src="http://technologistic.com.mx/wp-content/uploads/2025/05/Logo-Technologistic.jpeg" alt="Logo" style={{ height: '50px', marginBottom: '16px' }} />

        <Typography component="h1" variant="h5">Iniciar Sesión</Typography>

        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>

          <TextField

            margin="normal" required fullWidth id="email" label="Correo Electrónico"

            name="email" autoComplete="email" autoFocus value={email}

            onChange={(e) => setEmail(e.target.value)}

          />

          <TextField

            margin="normal" required fullWidth name="password" label="Contraseña"

            type="password" id="password" autoComplete="current-password" value={password}

            onChange={(e) => setPassword(e.target.value)}

          />

          {error && <Typography color="error" align="center" sx={{ mt: 2 }}>{error}</Typography>}

          <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>

            Ingresar

          </Button>

          <Grid container>

            <Grid item xs>

              <Link component={RouterLink} to="/forgot-password" variant="body2">

                Olvidé mi contraseña

              </Link>

            </Grid>

            <Grid item>

              <Link component={RouterLink} to="/register" variant="body2">

                {"¿No tienes cuenta? Regístrate"}

              </Link>

            </Grid>

          </Grid>

        </Box>

      </Paper>

    </Container>

  );

};


export default LoginPage;
